import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef } from "vue"
import _imports_0 from '../../assets/img/dropselect2.png'
import _imports_1 from '../../assets/img/noImg.png'
import _imports_2 from '../../assets/zt_404.png'
import _imports_3 from '@/assets/img/tips／exclamation-circle-fill@2x.png'


const _hoisted_1 = { style: {"background-color":"#F5F5F5","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "newTrialMaterial comBox" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "newTrialMaterial_box" }
const _hoisted_6 = { class: "el-dropdown-link" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { style: {"display":"flex"} }
const _hoisted_9 = {
  style: {},
  class: "table_img"
}
const _hoisted_10 = { class: "table_information" }
const _hoisted_11 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","color":"#333333"} }
const _hoisted_12 = { style: {"color":"#86909C","font-size":"0.14rem"} }
const _hoisted_13 = {
  key: 0,
  style: {"color":"#F53F3F","font-size":"0.14rem"}
}
const _hoisted_14 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  style: {"color":"#C01A26"}
}
const _hoisted_18 = {
  key: 1,
  style: {"height":"550px"}
}
const _hoisted_19 = { style: {"text-align":"center","font-size":"0.16rem","margin":"0.16rem 0"} }
const _hoisted_20 = { style: {"display":"flex","justify-content":"center"} }

import leftTemplate1 from '@/components/leftTemplate1.vue'
import {
	ref
} from 'vue'
import type {
	TabsPaneContext
} from 'element-plus'
import {
	ElMessage,
	ElTable
} from 'element-plus'
import {
	Axios
} from "../../assets/js/ls_com_axios.js";
import {
	serverUrls
} from "../../assets/js/ls_tgServerUrls.js";


import {
	useRouter
} from "vue-router";
interface User {
	date: string
	name: string
	address: string
	katype: string
	pirce: string,
	number: number,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'newTrialMaterial',
  setup(__props) {

let pageDef = ref({
	pageNum: 1,
	pageSize: 10,
	total: 0
})
//审核未审核状态
const active_value = ref(0);
if (localStorage.getItem("zssc")) {
	active_value.value = localStorage.getItem("zssc") == 'first' ? 0 : localStorage.getItem("zssc") == 'second' ? 1 : '-1'
} else {
	active_value.value = 0
}
const page = pageDef;
const activeName = ref('')
if (localStorage.getItem("zssc")) {
	activeName.value = localStorage.getItem("zssc")

} else {
	activeName.value = 'first'

}
// 类型
const top_type = ref('')
if (localStorage.getItem("zssc_type")) {
	top_type.value = localStorage.getItem("zssc_type")
} else {
	//  localStorage.setItem("zssc_type" , 0)
	// top_type.value = localStorage.getItem("zssc_type")

}
const activeList = ref([{
	label: '审核中',
	name: 'first',
	satus: '0',
},
{
	label: '未通过',
	name: 'third',
	satus: '-1',
}
])

const handleClick = (tab: TabsPaneContext, event: Event) => {
	localStorage.setItem("zssc", tab)
	isTableLoading.value = false;
	active_value.value = localStorage.getItem("zssc") == 'first' ? 0 : localStorage.getItem("zssc") == 'second' ? 1 : '-1';
	init();
}
// handleClick('first' ,  '')
// 表格
const allCheckbox = ref(false)

const multipleTableRef = ref<InstanceType<typeof ElTable>>()
const multipleSelection = ref<User[]>([])
const toggleSelection = (rows?: User[]) => {
	if (rows) {
		rows.forEach((row) => {
			multipleTableRef.value!.toggleRowSelection(row, undefined)
		})
	} else {
		multipleTableRef.value!.clearSelection()
	}
}
const handleSelectionChange = (val: User[]) => {
	multipleSelection.value = val
}
//列表请求
var data = []; // 创建一个空数组
let memberId = JSON.parse(localStorage.getItem('userList')).memberId;
const isTableLoading = ref(false);

const init = () => {
	console.log(top_type.value)
	console.log("===========================")

	let paramsA = {}
	if (top_type.value) {
		paramsA = {
			memberId: memberId,
			status: active_value.value || 0,
			materialType: top_type.value,
			pageNum: page.value.pageNum,
			pageSize: page.value.pageSize,
			orderByColumn: 'createTime',
			isAsc: 'desc'
		}
	} else {
		paramsA = {
			memberId: memberId,
			status: active_value.value || 0,
			pageNum: page.value.pageNum,
			pageSize: page.value.pageSize,
			orderByColumn: 'createTime',
			isAsc: 'desc'
		}
	}
	isTableLoading.value = false;
	Axios('get', '/fodder/manage/audit-list', paramsA, false, function (res) {
		if (res.data.rows.length != 0) {
			data = res.data.rows;
			page.value.total = res.data.total;
			setTimeout(() => {
				isTableLoading.value = true;
			}, 50)
		} else {
			setTimeout(() => {
				data = [];
				isTableLoading.value = true;
			}, 50)
		}


	})
	Axios('get', `/fodder/my-count/${memberId}`, {}, false, function (res) {
		console.log(res.data.rows)
	})

}
init();
// 删除、批量删除


let title = ref('');
let dialogDelVisible = ref(false);
let idArray = ref([]);
const handleDel = (index, row, type) => {
	title.value = type == 'del' ? '删除后则无法恢复，是否继续？' : '是否确认将所选全部在售素材？'
	if (type == 'del') {
		if (row.id) {
			idArray = [row.id]
			dialogDelVisible.value = true;
		} else {
			fileList.splice(index, 1);
		}
	} else {
		dialogDelVisible.value = true;
	}

}
const delSubmit = () => {
	Axios('delete', `/fodder/manage/remove/${idArray}`, {}, false, (res) => {
		if (res.data.code == 200) {
			dialogDelVisible.value = false;
			// 要删除的索引数组
			isTableLoading.value = false;
			init();

			ElMessage({
				message: '删除成功',
				type: 'success',
			})
		} else {
			ElMessage({
				message: '删除错误',
				type: 'error',
			})
		}

	})

}
//完善信息
const router = useRouter();
// handlePerfect
const handlePerfect = (row) => {

	// IMAGE, MUSIC, VIDEO
	if (row.materialType == 'VIDEO') {
		router.push({

			path: '/materiaPerfect',
			query: {
				id: row.id
			}

		},)
	} else if (row.materialType == 'MUSIC') {
		router.push({

			path: '/musicPerfect',
			query: {
				id: row.id
			}

		},)
	} else if (row.materialType == 'IMAGE') {
		router.push({

			path: '/picturePerfect',
			query: {
				id: row.id
			}

		},)
	}

}

//全部素材选择

const dropdownClick = (command: string | number | object) => {
	localStorage.setItem('zssc_type', command)
	top_type.value = localStorage.getItem('zssc_type');
	console.log(top_type.value)
	console.log('top_type.value------')

	init()
}
/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 * 
 */
const sizeChange = (val: number) => {
	init();
}
const currentChange = (val: number) => {
	page.value.pageNum = val;
	init();
}
const prevClick = (val: number) => {
	page.value.pageNum = val;
	init();
}
const nextClick = (val: number) => {
	page.value.pageNum = val;
	init();

}

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate1, { left_tabShow: 'new_trial_material' })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"height":"0.08rem"} }, null, -1)),
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeName).value = $event)),
          class: "demo-tabs",
          onTabChange: handleClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeList.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                label: item.label,
                name: item.name,
                key: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_dropdown, { onCommand: dropdownClick }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, { command: "" }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("全部素材/模板")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, { command: "VIDEO" }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("视频")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, { command: "MUSIC" }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("音乐")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, { command: "IMAGE" }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode("图片")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, [
                          _createTextVNode(_toDisplayString(top_type.value == 'MUSIC' ? '音乐' : top_type.value == 'VIDEO' ? '视频' : top_type.value == 'IMAGE' ? '图片'
										: '全部素材/模板') + " ", 1),
                          _cache[5] || (_cache[5] = _createElementVNode("img", {
                            style: {"width":"14px","height":"14px"},
                            src: _imports_0
                          }, null, -1))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", null, [
                    (isTableLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_unref(data).length != 0)
                            ? (_openBlock(), _createBlock(_unref(ElTable), {
                                key: 0,
                                ref_for: true,
                                ref_key: "multipleTableRef",
                                ref: multipleTableRef,
                                "show-header": false,
                                data: _unref(data),
                                style: {"width":"100%"},
                                height: "450"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    property: "name",
                                    label: "商品信息"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                          _createVNode(_component_el_image, {
                                            style: {"width":"100%","height":"100%"},
                                            src: scope.row.showImage || scope.row.filePath,
                                            "zoom-rate": 1.2,
                                            "initial-index": 4,
                                            fit: "cover"
                                          }, {
                                            error: _withCtx(() => _cache[10] || (_cache[10] = [
                                              _createElementVNode("div", {
                                                class: "image-slot",
                                                style: {"width":"100%","height":"100%"}
                                              }, [
                                                _createElementVNode("img", {
                                                  style: {"width":"100%","height":"100%"},
                                                  src: _imports_1
                                                })
                                              ], -1)
                                            ])),
                                            _: 2
                                          }, 1032, ["src"])
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                          _createElementVNode("div", _hoisted_11, _toDisplayString(scope.row.title) + _toDisplayString(scope.row.fileExt), 1),
                                          _createElementVNode("div", _hoisted_12, _toDisplayString(scope.row.updateTime) + "提交审核 ", 1),
                                          (scope.row.status == '-1')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 审核未通过：" + _toDisplayString(scope.row.auditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    label: "操作",
                                    width: item.satus == 2 ? '80' : '190'
                                  }, {
                                    default: _withCtx((scope) => [
                                      (item.satus != '0')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createElementVNode("div", {
                                              style: {"width":"100px","cursor":"pointer"},
                                              class: "topBtn",
                                              onClick: ($event: any) => (handlePerfect(scope.row,))
                                            }, " 修改信息", 8, _hoisted_15),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (handleDel(scope.$index, scope.row, 'del')),
                                              style: {"color":"#FF2929","margin-left":"0.1rem","line-height":"0.43rem","cursor":"pointer"}
                                            }, " 删除 ", 8, _hoisted_16)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_17, " 审核中 "))
                                    ]),
                                    _: 2
                                  }, 1032, ["width"])
                                ]),
                                _: 2
                              }, 1032, ["data"]))
                            : _createCommentVNode("", true),
                          (_unref(data).length != 0)
                            ? (_openBlock(), _createBlock(_component_el_pagination, {
                                key: 1,
                                "current-page": _unref(page).pageNum,
                                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_unref(page).pageNum) = $event)),
                                "page-size": _unref(page).pageSize,
                                "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_unref(page).pageSize) = $event)),
                                onSizeChange: sizeChange,
                                onCurrentChange: currentChange,
                                style: {"margin":"0.4rem 0"},
                                background: "",
                                layout: "prev, pager, next",
                                total: _unref(page).total
                              }, null, 8, ["current-page", "page-size", "total"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(data).length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[11] || (_cache[11] = [
                          _createElementVNode("div", { style: {"width":"60%","margin":"0 auto"} }, [
                            _createElementVNode("img", {
                              style: {"width":"100%","margin":"0 auto"},
                              src: _imports_2
                            })
                          ], -1)
                        ])))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: _unref(dialogDelVisible),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(dialogDelVisible) ? (dialogDelVisible).value = $event : dialogDelVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"width":"0.4rem","height":"0.4rem","margin":"0 auto"} }, [
          _createElementVNode("img", {
            style: {"height":"100%"},
            src: _imports_3
          })
        ], -1)),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(title)), 1),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(dialogDelVisible) //@ts-ignore
 ? dialogDelVisible.value = false : dialogDelVisible = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: delSubmit
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})